import {
    IProfileChild,
    IProfileOptionsResponse,
    IUserProfileUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { CollapsiblePane } from 'components/expandable_pane/CollapsiblePane';
import { PaneSection } from 'components/expandable_pane/PaneSection';
import { ProfileSettingDropdownInlineEditor } from 'components/inline_edit/ProfileSettingDropdownInlineEditor';
import { useState } from 'react';

export type OtherIndicatorOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    profile: IProfileChild;
    className?: string;
    onChange: (updates: Partial<IUserProfileUpdateRequest>) => void;
}>;

export function OtherIndicatorOptionsPane({
    options: { PressureUnits, TemperatureUnits },
    profile,
    className,
    onChange,
}: OtherIndicatorOptionsPaneProps) {
    const [expanded, setExpanded] = useState(false);

    return (
        <CollapsiblePane
            expanded={expanded}
            onChange={setExpanded}
            className={className}
            title="Other Indicator Units"
        >
            <PaneSection label="Temperature Units">
                <ProfileSettingDropdownInlineEditor
                    options={TemperatureUnits}
                    value={
                        TemperatureUnits.find(
                            (option) => option.Value === profile.TemperatureUnits
                        ) ?? TemperatureUnits[0]
                    }
                    onConfirm={(value) => onChange({ TemperatureUnits: value?.Value })}
                />
            </PaneSection>
            <PaneSection label="Pressure Units">
                <ProfileSettingDropdownInlineEditor
                    options={PressureUnits}
                    value={
                        PressureUnits.find(
                            (option) => option.Value === profile.PressureUnits
                        ) ?? PressureUnits[0]
                    }
                    onConfirm={(value) => onChange({ PressureUnits: value?.Value })}
                />
            </PaneSection>
        </CollapsiblePane>
    );
}
